(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-info-text"] && !Shopify.designMode) return;
  try {
    class ReadingTimeComponent extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.render(), { once: true });
      } else {
        this.render();
      }
    }

    render() {
      const selector = this.dataset.contentSelector || '.blog-post-content';
      const content = document.querySelector(selector);
      if (!content) return;

      const words = (content.textContent || '').trim().split(/\s+/).filter(Boolean).length;
      if (!words) return;

      const wpm = parseInt(this.dataset.wordsPerMinute, 10) || 200;
      const minutes = Math.max(1, Math.ceil(words / wpm));

      const template = this.dataset.labelTemplate || '%COUNT% min read';
      const label = template.replace('%COUNT%', minutes);
      const separator = this.dataset.separator;

      this.textContent = separator ? separator + ' ' + label : label;
      this.hidden = false;
    }
  }

  if (!customElements.get('reading-time')) {
    customElements.define('reading-time', ReadingTimeComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cta-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(e) {
    var link = e.target.closest('[data-scroll-to-atc]');
    if (!link) return;
    e.preventDefault();

    // Find the main add-to-cart form or buy-buttons block
    var atc = document.querySelector('[data-type="add-to-cart-form"]')
      || document.querySelector('.buy-buttons-block');
    if (!atc) return;

    // Scroll so the ATC button sits 10px above the bottom of the viewport
    var rect = atc.getBoundingClientRect();
    var targetY = window.scrollY + rect.bottom - window.innerHeight + 10;
    window.scrollTo({ top: Math.max(0, targetY), behavior: 'smooth' });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["image-gallery"] && !Shopify.designMode) return;
  try {
    class ImageGalleryCarousel extends HTMLElement {
    connectedCallback() {
      this._viewport = this.querySelector('.image-gallery__viewport');
      this._track = this.querySelector('.image-gallery__track');
      this._slides = [...this._track.querySelectorAll('[data-index]')];
      this._dots = [...this.querySelectorAll('.image-gallery__dot')];
      this._prevBtn = this.querySelector('[data-dir="prev"]');
      this._nextBtn = this.querySelector('[data-dir="next"]');

      this._slideCount = this._slides.length;
      this._current = 0;
      this._currentX = 0;
      this._isDragging = false;
      this._dragMoved = false;
      this._isAnimating = false;
      this._autoplayTimer = null;

      if (this._slideCount < 2) {
        this.classList.add('is-ready');
        return;
      }

      this._createClones();
      this._goTo(0, false);
      this._bindEvents();
      this._startAutoplay();
      this.classList.add('is-ready');
    }

    disconnectedCallback() {
      this._stopAutoplay();
    }

    /* ── Clones ── */

    _createClones() {
      /* Clone the full slide set on each side so there are always
         enough clones to fill the viewport during wrap transitions. */
      this._cloneCount = this._slideCount;

      /* Prepend clones in reverse order so they end up
         [0', 1', ..., N-1', REAL_0, REAL_1, ...] */
      for (let i = this._cloneCount - 1; i >= 0; i--) {
        const clone = this._slides[i].cloneNode(true);
        clone.classList.add('is-clone');
        clone.removeAttribute('data-index');
        clone.setAttribute('aria-hidden', 'true');
        this._track.insertBefore(clone, this._track.firstChild);
      }

      /* Append clones of all slides. */
      for (let i = 0; i < this._cloneCount; i++) {
        const clone = this._slides[i].cloneNode(true);
        clone.classList.add('is-clone');
        clone.removeAttribute('data-index');
        clone.setAttribute('aria-hidden', 'true');
        this._track.appendChild(clone);
      }

      this._allSlides = [...this._track.children];
    }

    /* ── Centering offset ──
       Always places the active slide dead center in the viewport.
       Formula: -(realPos * slideWidth - (vpWidth - slideWidth) / 2) */

    _getOffset(index) {
      var slideWidth = this._allSlides[0].getBoundingClientRect().width;
      var vpWidth = this._viewport.getBoundingClientRect().width;
      var realPos = index + this._cloneCount;
      return -(realPos * slideWidth - (vpWidth - slideWidth) / 2);
    }

    /* ── Navigation ── */

    _goTo(index, animate) {
      if (animate === undefined) animate = true;
      if (animate && this._isAnimating) return;
      this._isAnimating = animate;
      this._current = index;

      if (animate) {
        this._track.style.transition = 'transform 0.45s cubic-bezier(0.25, 0.1, 0.25, 1)';
      } else {
        this._track.style.transition = 'none';
      }

      this._currentX = this._getOffset(index);
      this._track.style.transform = 'translateX(' + this._currentX + 'px)';
      this._updateDots();
    }

    next() { this._goTo(this._current + 1); }
    prev() { this._goTo(this._current - 1); }

    /* ── Clone boundary reset ── */

    _onTransitionEnd = (e) => {
      if (e.target !== this._track || e.propertyName !== 'transform') return;
      this._isAnimating = false;

      if (this._current >= this._slideCount) {
        this._track.style.transition = 'none';
        this._current = this._current - this._slideCount;
        this._currentX = this._getOffset(this._current);
        this._track.style.transform = 'translateX(' + this._currentX + 'px)';
        void this._track.offsetHeight;
        this._updateDots();
      } else if (this._current < 0) {
        this._track.style.transition = 'none';
        this._current = this._current + this._slideCount;
        this._currentX = this._getOffset(this._current);
        this._track.style.transform = 'translateX(' + this._currentX + 'px)';
        void this._track.offsetHeight;
        this._updateDots();
      }
    };

    /* ── UI updates ── */

    _updateDots() {
      var realIndex = ((this._current % this._slideCount) + this._slideCount) % this._slideCount;
      this._dots.forEach(function(dot, i) {
        dot.classList.toggle('is-active', i === realIndex);
        if (i === realIndex) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    /* ── Events ── */

    _bindEvents() {
      this._track.addEventListener('transitionend', this._onTransitionEnd);

      if (this._prevBtn) this._prevBtn.addEventListener('click', () => { this.prev(); this._restartAutoplay(); });
      if (this._nextBtn) this._nextBtn.addEventListener('click', () => { this.next(); this._restartAutoplay(); });

      this._dots.forEach((dot, i) => {
        dot.addEventListener('click', () => { this._goTo(i); this._restartAutoplay(); });
      });

      this._bindDrag();

      /* Recenter on resize */
      var self = this;
      window.addEventListener('resize', function() {
        clearTimeout(self._resizeTimer);
        self._resizeTimer = setTimeout(function() {
          self._goTo(self._current, false);
        }, 100);
      });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this._stopAutoplay();
        else this._startAutoplay();
      });
    }

    /* ── Drag / swipe ── */

    _bindDrag() {
      var self = this;
      var vp = this._viewport;
      var startX = 0;
      var startOffset = 0;
      var cachedSlideWidth = 0;

      vp.addEventListener('pointerdown', function(e) {
        if (e.button !== 0) return;
        e.preventDefault();
        self._isAnimating = false;
        self._isDragging = true;
        self._dragMoved = false;
        startX = e.clientX;
        startOffset = self._currentX;
        cachedSlideWidth = self._allSlides[0].getBoundingClientRect().width;
        self._track.style.transition = 'none';
        vp.setPointerCapture(e.pointerId);
        self._stopAutoplay();
      });

      vp.addEventListener('pointermove', function(e) {
        if (!self._isDragging) return;
        e.preventDefault();
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 5) self._dragMoved = true;
        self._currentX = startOffset + dx;
        self._track.style.transform = 'translateX(' + self._currentX + 'px)';
      });

      vp.addEventListener('pointerup', function(e) {
        if (!self._isDragging) return;
        self._isDragging = false;
        self._isAnimating = false;
        var dx = e.clientX - startX;
        var threshold = cachedSlideWidth * 0.15;

        if (Math.abs(dx) > threshold) {
          if (dx > 0) self.prev();
          else self.next();
        } else {
          self._goTo(self._current);
        }
        self._startAutoplay();
      });

      vp.addEventListener('pointercancel', function() {
        if (self._isDragging) {
          self._isDragging = false;
          self._isAnimating = false;
          self._goTo(self._current);
          self._startAutoplay();
        }
      });

      /* Block iOS Safari back/forward edge-swipe gesture */
      vp.addEventListener('touchmove', function(e) {
        if (self._isDragging) {
          e.preventDefault();
        }
      }, { passive: false });

      /* Prevent accidental link clicks during drag */
      vp.addEventListener('click', function(e) {
        if (self._dragMoved) {
          e.preventDefault();
          e.stopPropagation();
          self._dragMoved = false;
        }
      }, true);
    }

    /* ── Autoplay ── */

    _startAutoplay() {
      var speed = parseInt(this.dataset.autoplaySpeed) || 3;
      this._stopAutoplay();
      var self = this;
      this._autoplayTimer = setInterval(function() { self.next(); }, speed * 1000);
    }

    _stopAutoplay() {
      if (this._autoplayTimer) {
        clearInterval(this._autoplayTimer);
        this._autoplayTimer = null;
      }
    }

    _restartAutoplay() {
      this._stopAutoplay();
      this._startAutoplay();
    }
  }

  if (!customElements.get('image-gallery-carousel')) {
    customElements.define('image-gallery-carousel', ImageGalleryCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["image-marquee"] && !Shopify.designMode) return;
  try {
    class ImageMarquee extends HTMLElement {
    connectedCallback() {
      this._wrapper = this.querySelector('.image-marquee__wrapper');
      this._content = this.querySelector('.image-marquee__content');

      if (!this._content || this._content.children.length === 0) return;

      /* Wait one frame for layout so measurements are accurate */
      requestAnimationFrame(function() {
        this._init();
      }.bind(this));
    }

    _init() {
      var containerWidth = this.offsetWidth;
      var contentWidth = this._content.scrollWidth;

      if (contentWidth === 0) return;

      /* Enough copies to overfill the viewport so the loop is seamless */
      var copies = Math.max(2, Math.ceil(containerWidth / contentWidth) + 1);

      /* Clone the original set of items to fill the viewport */
      var originals = [];
      for (var c = 0; c < this._content.children.length; c++) {
        originals.push(this._content.children[c]);
      }

      for (var i = 1; i < copies; i++) {
        for (var j = 0; j < originals.length; j++) {
          var clone = originals[j].cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          this._content.appendChild(clone);
        }
      }

      /* Duplicate the entire content div for the seamless loop.
         CSS translates -50% so the second copy scrolls into view
         exactly as the first scrolls out. */
      var contentClone = this._content.cloneNode(true);
      contentClone.setAttribute('aria-hidden', 'true');
      this._wrapper.appendChild(contentClone);

      /* Speed: slider 1 (slow) to 10 (fast).
         Map to a duration factor so higher = shorter duration = faster. */
      var speed = parseInt(this.dataset.speed) || 5;
      var speedFactor = Math.max(5, 55 - speed * 5);
      var duration = Math.sqrt(copies) * speedFactor;
      this.style.setProperty('--marquee-speed', duration + 's');
    }
  }

  if (!customElements.get('image-marquee')) {
    customElements.define('image-marquee', ImageMarquee);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pack-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pack-selector-component')) {
    class PackSelectorComponent extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', () => this.sync());
        const coupon = this.querySelector('.pack-selector__coupon');
        if (coupon) {
          coupon.addEventListener('click', () => {
            const two = this.querySelector('.pack-selector__radio[value="2"]');
            if (two && !two.checked) {
              two.checked = true;
              two.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        }
        this.sync();
      }

      // Radios are per-instance UI; the form's real quantity lives in one shared
      // hidden input so stacked layout-comparison instances don't collide.
      sync() {
        const checked = this.querySelector('.pack-selector__radio:checked');
        if (!checked) return;

        const form = document.getElementById(this.dataset.formId);
        if (form) {
          let input = form.querySelector('input[type="hidden"][name="quantity"][data-pack-selector]');
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'quantity';
            input.setAttribute('data-pack-selector', '');
            form.appendChild(input);
          }
          input.value = checked.value;
        }

        const coupon = this.querySelector('.pack-selector__coupon');
        if (coupon) coupon.disabled = checked.value === '2';
      }
    }
    customElements.define('pack-selector-component', PackSelectorComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["review-marquee"] && !Shopify.designMode) return;
  try {
    class ReviewMarquee extends HTMLElement {
    connectedCallback() {
      this._wrapper = this.querySelector('.review-marquee__wrapper');
      this._content = this.querySelector('.review-marquee__content');

      if (!this._content || this._content.children.length === 0) return;

      requestAnimationFrame(function() {
        this._init();
      }.bind(this));
    }

    _init() {
      var containerWidth = this.offsetWidth;
      var contentWidth = this._content.scrollWidth;

      if (contentWidth === 0) return;

      var copies = Math.max(2, Math.ceil(containerWidth / contentWidth) + 1);

      var originals = [];
      for (var c = 0; c < this._content.children.length; c++) {
        originals.push(this._content.children[c]);
      }

      for (var i = 1; i < copies; i++) {
        for (var j = 0; j < originals.length; j++) {
          var clone = originals[j].cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          this._content.appendChild(clone);
        }
      }

      var contentClone = this._content.cloneNode(true);
      contentClone.setAttribute('aria-hidden', 'true');
      this._wrapper.appendChild(contentClone);

      var speed = parseInt(this.dataset.speed) || 5;
      var speedFactor = Math.max(5, 55 - speed * 5);
      var duration = Math.sqrt(copies) * speedFactor;
      this.style.setProperty('--review-marquee-speed', duration + 's');
    }
  }

  if (!customElements.get('review-marquee')) {
    customElements.define('review-marquee', ReviewMarquee);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["text-fit"] && !Shopify.designMode) return;
  try {
    class TextFitComponent extends HTMLElement {
    connectedCallback() {
      this.heading = this.querySelector('.text-fit__heading');
      if (!this.heading) return;
      this.ro = new ResizeObserver(() => this.fit());
      this.ro.observe(this);
      requestAnimationFrame(() => this.fit());
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
    }

    fit() {
      const h = this.heading;
      const w = this.clientWidth;
      if (!w) return;

      h.style.fontSize = '100px';
      h.style.position = 'absolute';
      h.style.width = 'auto';
      h.style.visibility = 'hidden';

      const tw = h.getBoundingClientRect().width;

      h.style.position = '';
      h.style.width = '';
      h.style.visibility = '';

      if (!tw) return;

      const s = getComputedStyle(this);
      const min = parseFloat(s.getPropertyValue('--fit-min')) || 16;
      const max = parseFloat(s.getPropertyValue('--fit-max')) || 200;
      const ideal = (w / tw) * 100;

      h.style.fontSize = Math.min(max, Math.max(min, ideal)) + 'px';
    }
  }

  customElements.define('text-fit-component', TextFitComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ugc-gallery"] && !Shopify.designMode) return;
  try {
    class UGCGalleryComponent extends HTMLElement {
    connectedCallback() {
      // Theme editor moves (reorder) disconnect + reconnect the same instance;
      // listeners are already bound, so only re-arm the observer.
      if (this._initialized) {
        if (this._ro && this.track) this._ro.observe(this.track);
        return;
      }
      this._initialized = true;

      this.track = this.querySelector('.ugc-gallery__track');
      this.arrowLeft = this.querySelector('.ugc-gallery__arrow--left');
      this.arrowRight = this.querySelector('.ugc-gallery__arrow--right');
      this.dialog = this.querySelector('.ugc-gallery__modal');
      this.viewport = this.querySelector('.ugc-gallery__modal-viewport');
      this.muteBtn = this.querySelector('.ugc-gallery__mute-btn');
      this.closeBtn = this.querySelector('.ugc-gallery__close');
      this.expandBtn = this.querySelector('.ugc-gallery__expand-btn');
      this.backdrop = this.querySelector('.ugc-gallery__backdrop');
      this.playBtn = this.querySelector('.ugc-gallery__play-btn');
      this.prevBtn = this.querySelector('.ugc-gallery__prev-btn');
      this.nextBtn = this.querySelector('.ugc-gallery__next-btn');

      // Two video elements for slide transitions
      var videoEls = this.querySelectorAll('.ugc-gallery__video');
      this._videoA = videoEls[0];
      this._videoB = videoEls[1];
      this._activeVideo = this._videoA;

      if (!this.track) return;

      try {
        this.videos = JSON.parse(this.getAttribute('data-videos') || '[]');
      } catch (err) {
        this.videos = [];
      }
      this.currentIndex = 0;
      this._prevScrollY = 0;
      this._touchStartY = 0;
      this._transitioning = false;
      this._isMuted = false;
      this._bodyLocked = false;
      this._switchingModes = false;
      this._pendingTransition = null;
      this._arrowsRaf = null;
      this._playerMode = this.getAttribute('data-player-style') || 'fullscreen';

      var self = this;

      // On ended: a single video just restarts (no self-slide), otherwise advance
      [this._videoA, this._videoB].forEach(function(v) {
        if (!v) return;
        v.addEventListener('ended', function() {
          if (self.videos.length < 2) {
            v.currentTime = 0;
            self._play(v);
          } else {
            self.nextVideo();
          }
        });
      });

      // Drag-to-reveal touch handling on the viewport
      if (this.viewport) {
        this._dragging = false;
        this._dragIncoming = null;
        this._dragDirection = null;

        this.viewport.addEventListener('touchstart', function(e) {
          if (this._transitioning || this.videos.length < 2) return;
          // A second finger mid-drag must not reset drag state
          if (this._dragging || this._dragIncoming || e.touches.length > 1) return;
          this._touchStartY = e.changedTouches[0].clientY;
          this._dragging = false;
          this._dragDirection = null;
        }.bind(this), { passive: true });

        this.viewport.addEventListener('touchmove', function(e) {
          if (this._transitioning || this.videos.length < 2) return;
          if (!this._dragging && this._dragIncoming) return;
          var currentY = e.changedTouches[0].clientY;
          var deltaY = this._touchStartY - currentY;

          // Ignore tiny movements
          if (!this._dragging && Math.abs(deltaY) < 8) return;

          // First real move: determine direction and prep incoming video
          if (!this._dragging) {
            this._dragging = true;
            this._dragDirection = (deltaY > 0) ? 'up' : 'down';
            var nextIdx = this._wrapIndex(
              this.currentIndex + (this._dragDirection === 'up' ? 1 : -1)
            );

            var outgoing = this._activeVideo;
            var incoming = (outgoing === this._videoA) ? this._videoB : this._videoA;
            this._dragIncoming = incoming;

            // Load and position incoming off-screen (plays after commit).
            // metadata only: cancelled swipes must not download whole videos.
            incoming.preload = 'metadata';
            incoming.poster = this.videos[nextIdx].poster || '';
            incoming.src = this.videos[nextIdx].src;
            incoming.muted = this._isMuted;
            incoming.classList.remove('ugc-gallery__video--active', 'ugc-gallery__video--sliding');
            incoming.style.transition = 'none';
            incoming.style.transform = (this._dragDirection === 'up')
              ? 'translateY(100%)' : 'translateY(-100%)';
            incoming.classList.add('ugc-gallery__video--visible');

            // Kill transition on outgoing too so it tracks the finger
            outgoing.classList.remove('ugc-gallery__video--sliding');
            outgoing.style.transition = 'none';
          }

          // Move both videos with the finger
          var vpHeight = this.viewport.offsetHeight;
          var clamped = Math.max(-vpHeight, Math.min(vpHeight, deltaY));
          var pxOffset = -clamped;

          this._activeVideo.style.transform = 'translateY(' + pxOffset + 'px)';

          if (this._dragDirection === 'up') {
            this._dragIncoming.style.transform = 'translateY(' + (vpHeight + pxOffset) + 'px)';
          } else {
            this._dragIncoming.style.transform = 'translateY(' + (-vpHeight + pxOffset) + 'px)';
          }
        }.bind(this), { passive: true });

        this.viewport.addEventListener('touchend', function(e) {
          if (!this._dragging || this._transitioning) return;
          this._dragging = false;

          var deltaY = this._touchStartY - e.changedTouches[0].clientY;
          var vpHeight = this.viewport.offsetHeight;
          var threshold = vpHeight * 0.2;
          var pastThreshold = Math.abs(deltaY) > threshold;
          var correctDirection = (this._dragDirection === 'up') ? (deltaY > 0) : (deltaY < 0);

          if (pastThreshold && correctDirection) {
            // Commit: animate to final position
            this._commitDrag();
          } else {
            // Rubber-band back
            this._cancelDrag();
          }
        }.bind(this), { passive: true });
      }

      // Arrow updates on scroll and resize (rAF-throttled: scroll fires per
      // frame during smooth scrolling and the handler does layout reads)
      this._requestArrowUpdate = function() {
        if (self._arrowsRaf) return;
        self._arrowsRaf = requestAnimationFrame(function() {
          self._arrowsRaf = null;
          self.updateArrows();
        });
      };
      this.track.addEventListener('scroll', this._requestArrowUpdate);
      this._ro = new ResizeObserver(this._requestArrowUpdate);
      this._ro.observe(this.track);
      this._requestArrowUpdate();

      // Arrow clicks
      if (this.arrowLeft) {
        this.arrowLeft.addEventListener('click', function() { this.scrollTrack(-1); }.bind(this));
      }
      if (this.arrowRight) {
        this.arrowRight.addEventListener('click', function() { this.scrollTrack(1); }.bind(this));
      }

      // Thumbnail clicks
      this.querySelectorAll('.ugc-gallery__thumb').forEach(function(btn) {
        btn.addEventListener('click', function() {
          this.openVideo(parseInt(btn.dataset.index, 10));
        }.bind(this));
      }.bind(this));

      // Modal close handlers
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', this.closeModal.bind(this));
      }
      if (this.dialog) {
        this.dialog.addEventListener('keydown', function(e) {
          if (e.key === 'Escape') { e.preventDefault(); this.closeModal(); }
          if (e.key === 'ArrowUp') { e.preventDefault(); this.prevVideo(); }
          if (e.key === 'ArrowDown') { e.preventDefault(); this.nextVideo(); }
        }.bind(this));
        this.dialog.addEventListener('click', function(e) {
          if (e.target === this.dialog || e.target === this.backdrop) this.closeModal();
        }.bind(this));
        // Cleanup on ANY close path (Escape via cancel, dev tools, future
        // light-dismiss), not just our own closeModal. The close event fires
        // as a queued task (async), so the mode-switch flag is consumed here
        // rather than reset synchronously after close().
        this.dialog.addEventListener('close', function() {
          if (this._switchingModes) {
            this._switchingModes = false;
            return;
          }
          if (this.dialog.open) return; // reopened before the async event fired
          this._handleDialogClosed();
        }.bind(this));
      }

      // Expand / minimize toggle
      if (this.expandBtn) {
        this.expandBtn.addEventListener('click', function() {
          if (this._playerMode === 'mini') {
            this.expandToFullscreen();
          } else {
            this.minimizeToMini();
          }
        }.bind(this));
      }

      // Prev / next button clicks
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', this.prevVideo.bind(this));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', this.nextVideo.bind(this));
      }

      // Mute toggle
      if (this.muteBtn) {
        this.muteBtn.addEventListener('click', this.toggleMute.bind(this));
      }

      // Play/pause toggle (button + tap viewport)
      if (this.playBtn) {
        this.playBtn.addEventListener('click', this.togglePlay.bind(this));
      }
      if (this.viewport) {
        this.viewport.addEventListener('click', function(e) {
          if (e.target.closest('.ugc-gallery__modal-controls') || e.target.closest('.ugc-gallery__play-btn')) return;
          this.togglePlay();
        }.bind(this));
      }
    }

    disconnectedCallback() {
      if (this._ro) this._ro.disconnect();
      if (this._arrowsRaf) {
        cancelAnimationFrame(this._arrowsRaf);
        this._arrowsRaf = null;
      }
      this._abortPendingTransition();

      // The mini player reparents the dialog to <body>; removing the component
      // (theme editor re-render) would otherwise orphan a playing dialog and
      // leave the fullscreen body scroll-lock engaged.
      if (this.dialog) {
        if (this.dialog.open) {
          this._switchingModes = true;
          this.dialog.close();
        }
        this._resetVideo(this._videoA);
        this._resetVideo(this._videoB);
        this._unlockBody();
        if (this.dialog.parentNode && this.dialog.parentNode !== this) {
          this.dialog.remove();
        }
      }
    }

    /* ── Gallery track ── */

    updateArrows() {
      if (!this.track) return;
      var sl = this.track.scrollLeft;
      var sw = this.track.scrollWidth;
      var cw = this.track.clientWidth;
      if (this.arrowLeft) this.arrowLeft.hidden = sl <= 1;
      if (this.arrowRight) this.arrowRight.hidden = sl + cw >= sw - 1;
    }

    scrollTrack(direction) {
      var first = this.track.firstElementChild;
      if (!first) return;
      var amount = (first.offsetWidth + 10) * 2;
      this.track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    /* ── Modal open / close ── */

    openVideo(index) {
      if (!this.videos.length || !this.dialog) return;
      var entry = this.videos[this._wrapIndex(index)];
      if (!entry || !entry.src) return;

      this._abortPendingTransition();
      this.currentIndex = this._wrapIndex(index);
      this._isMuted = false;

      // Reset both videos
      this._resetVideo(this._videoA);
      this._resetVideo(this._videoB);
      this._videoA.classList.add('ugc-gallery__video--active');
      this._videoB.classList.remove('ugc-gallery__video--active');
      this._activeVideo = this._videoA;

      this._activeVideo.preload = 'auto';
      this._activeVideo.poster = entry.poster || '';
      this._activeVideo.src = entry.src;
      this._activeVideo.muted = this._isMuted;
      this._play(this._activeVideo);
      this.updateMuteIcon();
      this.updateExpandIcon();
      this.updatePlayIcon();

      // No prev/next with a single video
      var showNav = this.videos.length > 1;
      if (this.prevBtn) this.prevBtn.hidden = !showNav;
      if (this.nextBtn) this.nextBtn.hidden = !showNav;

      // Apply mode class and open
      this.dialog.classList.remove('ugc-gallery__modal--fullscreen', 'ugc-gallery__modal--mini');
      this.dialog.classList.add('ugc-gallery__modal--' + this._playerMode);

      if (this._playerMode === 'fullscreen') {
        this._lockBody();
        this._returnDialog();
        this.dialog.showModal();
      } else {
        // Move dialog to body so it escapes all parent stacking contexts
        document.body.appendChild(this.dialog);
        this.dialog.show();
      }
    }

    closeModal() {
      if (!this.dialog) return;
      if (this.dialog.open) {
        this.dialog.close(); // 'close' handler runs _handleDialogClosed
      } else {
        this._handleDialogClosed();
      }
    }

    /* Runs exactly once per close, regardless of how the dialog closed */
    _handleDialogClosed() {
      this._abortPendingTransition();
      this._resetVideo(this._videoA);
      this._resetVideo(this._videoB);
      this._unlockBody();
      this.dialog.classList.remove('ugc-gallery__modal--fullscreen', 'ugc-gallery__modal--mini');
      this._returnDialog();

      // Reset to default mode for next open
      this._playerMode = this.getAttribute('data-player-style') || 'fullscreen';
    }

    /* ── Body scroll lock (fullscreen mode) ── */

    _lockBody() {
      if (this._bodyLocked) return;
      this._bodyLocked = true;
      this._prevScrollY = window.scrollY;
      // Compensate the vanishing scrollbar so the page doesn't shift
      var scrollbar = window.innerWidth - document.documentElement.clientWidth;
      if (scrollbar > 0) document.body.style.paddingRight = scrollbar + 'px';
      document.body.style.width = '100%';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + this._prevScrollY + 'px';
    }

    _unlockBody() {
      if (!this._bodyLocked) return;
      this._bodyLocked = false;
      document.body.style.paddingRight = '';
      document.body.style.width = '';
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo({ top: this._prevScrollY, behavior: 'instant' });
    }

    /* Move dialog back inside the component */
    _returnDialog() {
      if (this.dialog.parentNode !== this) {
        this.appendChild(this.dialog);
      }
    }

    expandToFullscreen() {
      var time = this._activeVideo ? this._activeVideo.currentTime : 0;
      var wasMuted = this._isMuted;
      var wasPaused = this._activeVideo ? this._activeVideo.paused : false;

      // Suppress the 'close' cleanup: this close is a mode switch, not an
      // exit. The flag is consumed by the (async) close event handler.
      this._switchingModes = true;
      this.dialog.close();
      this._returnDialog();

      this._lockBody();

      this.dialog.classList.remove('ugc-gallery__modal--mini');
      this.dialog.classList.add('ugc-gallery__modal--fullscreen');
      this._playerMode = 'fullscreen';

      this.dialog.showModal();

      if (this._activeVideo) {
        this._activeVideo.currentTime = time;
        this._activeVideo.muted = wasMuted;
        if (!wasPaused) this._play(this._activeVideo);
      }
      this.updateExpandIcon();
      this.updatePlayIcon();
    }

    minimizeToMini() {
      var time = this._activeVideo ? this._activeVideo.currentTime : 0;
      var wasMuted = this._isMuted;
      var wasPaused = this._activeVideo ? this._activeVideo.paused : false;

      this._switchingModes = true;
      this.dialog.close();

      this._unlockBody();

      this.dialog.classList.remove('ugc-gallery__modal--fullscreen');
      this.dialog.classList.add('ugc-gallery__modal--mini');
      this._playerMode = 'mini';

      document.body.appendChild(this.dialog);
      this.dialog.show();

      if (this._activeVideo) {
        this._activeVideo.currentTime = time;
        this._activeVideo.muted = wasMuted;
        if (!wasPaused) this._play(this._activeVideo);
      }
      this.updateExpandIcon();
      this.updatePlayIcon();
    }

    updateExpandIcon() {
      if (!this.expandBtn) return;
      var expandIcon = this.expandBtn.querySelector('.ugc-icon-expand');
      var minimizeIcon = this.expandBtn.querySelector('.ugc-icon-minimize');
      var isMini = this._playerMode === 'mini';
      if (expandIcon) expandIcon.classList.toggle('hidden', !isMini);
      if (minimizeIcon) minimizeIcon.classList.toggle('hidden', isMini);
      this.expandBtn.setAttribute('aria-label', isMini ? 'Expand' : 'Minimize');
    }

    /* ── Slide transitions ── */

    nextVideo() {
      this._slideToVideo(this.currentIndex + 1, 'up');
    }

    prevVideo() {
      this._slideToVideo(this.currentIndex - 1, 'down');
    }

    /* Button / keyboard / auto-advance: full animated slide */
    _slideToVideo(newIndex, direction) {
      if (this._transitioning || this.videos.length < 2) return;
      newIndex = this._wrapIndex(newIndex);
      if (newIndex === this.currentIndex) return;

      this._transitioning = true;
      this.currentIndex = newIndex;

      var outgoing = this._activeVideo;
      var incoming = (outgoing === this._videoA) ? this._videoB : this._videoA;
      var entry = this.videos[newIndex];

      // Load incoming video (plays after transition completes); buffer eagerly
      // so it's ready when the 350ms slide finishes
      incoming.preload = 'auto';
      incoming.poster = entry.poster || '';
      incoming.src = entry.src;
      incoming.muted = this._isMuted;

      // Position incoming off-screen (no transition yet)
      incoming.classList.remove('ugc-gallery__video--active', 'ugc-gallery__video--sliding');
      incoming.style.transition = 'none';
      incoming.style.transform = (direction === 'up') ? 'translateY(100%)' : 'translateY(-100%)';
      incoming.classList.add('ugc-gallery__video--visible');

      // Force reflow so the browser registers the starting position
      incoming.offsetHeight;

      // Animate both
      incoming.style.transition = '';
      outgoing.classList.add('ugc-gallery__video--sliding');
      incoming.classList.add('ugc-gallery__video--sliding');

      var outTarget = (direction === 'up') ? 'translateY(-100%)' : 'translateY(100%)';
      outgoing.style.transform = outTarget;
      incoming.style.transform = 'translateY(0)';

      this._finishTransition(outgoing, incoming);
    }

    /* Touch drag: commit the in-progress drag to completion */
    _commitDrag() {
      if (!this._dragIncoming) return;
      this._transitioning = true;
      this.currentIndex = this._wrapIndex(
        this.currentIndex + (this._dragDirection === 'up' ? 1 : -1)
      );

      var outgoing = this._activeVideo;
      var incoming = this._dragIncoming;

      // Committed: buffer the full video now
      incoming.preload = 'auto';

      // Re-enable transitions and animate to final positions
      outgoing.style.transition = '';
      incoming.style.transition = '';
      outgoing.classList.add('ugc-gallery__video--sliding');
      incoming.classList.add('ugc-gallery__video--sliding');

      var outTarget = (this._dragDirection === 'up') ? 'translateY(-100%)' : 'translateY(100%)';
      outgoing.style.transform = outTarget;
      incoming.style.transform = 'translateY(0)';

      this._finishTransition(outgoing, incoming);
    }

    /* Touch drag: rubber-band back to original position */
    _cancelDrag() {
      if (!this._dragIncoming) return;

      var self = this;
      var outgoing = this._activeVideo;
      var incoming = this._dragIncoming;

      // Block new drags/slides while snapping back
      this._transitioning = true;

      // Re-enable transitions and snap back
      outgoing.style.transition = '';
      incoming.style.transition = '';
      outgoing.classList.add('ugc-gallery__video--sliding');
      incoming.classList.add('ugc-gallery__video--sliding');

      outgoing.style.transform = 'translateY(0)';
      var resetPos = (this._dragDirection === 'up') ? 'translateY(100%)' : 'translateY(-100%)';
      incoming.style.transform = resetPos;

      var done = false;
      var timer;

      function finish() {
        if (done) return;
        done = true;
        clearTimeout(timer);
        incoming.removeEventListener('transitionend', finish);
        incoming.removeEventListener('transitioncancel', finish);
        if (self._pendingTransition && self._pendingTransition.abort === finish) {
          self._pendingTransition = null;
        }
        incoming.pause();
        incoming.removeAttribute('src');
        incoming.load();
        incoming.classList.remove('ugc-gallery__video--sliding', 'ugc-gallery__video--visible');
        incoming.style.transform = '';
        incoming.style.transition = '';
        outgoing.classList.remove('ugc-gallery__video--sliding');
        outgoing.style.transform = '';
        outgoing.style.transition = '';
        self._dragIncoming = null;
        self._transitioning = false;
      }

      this._pendingTransition = { abort: finish };
      incoming.addEventListener('transitionend', finish);
      incoming.addEventListener('transitioncancel', finish);
      // Safety: micro-drags can end with transforms already at target, in
      // which case no transition runs and transitionend never fires
      timer = setTimeout(finish, 450);
    }

    /* Shared cleanup after a slide completes (button or drag) */
    _finishTransition(outgoing, incoming) {
      var self = this;
      var done = false;
      var timer;

      function detach() {
        clearTimeout(timer);
        incoming.removeEventListener('transitionend', cleanup);
        incoming.removeEventListener('transitioncancel', cleanup);
        if (self._pendingTransition && self._pendingTransition.abort === abort) {
          self._pendingTransition = null;
        }
      }

      function cleanup() {
        if (done) return;
        done = true;
        detach();

        outgoing.pause();
        outgoing.removeAttribute('src');
        outgoing.load();
        outgoing.classList.remove('ugc-gallery__video--active', 'ugc-gallery__video--sliding', 'ugc-gallery__video--visible');
        outgoing.style.transform = '';
        outgoing.style.transition = '';

        incoming.classList.remove('ugc-gallery__video--sliding', 'ugc-gallery__video--visible');
        incoming.classList.add('ugc-gallery__video--active');
        incoming.style.transform = '';
        incoming.style.transition = '';

        self._activeVideo = incoming;
        self._play(incoming);
        self.updatePlayIcon();
        self._transitioning = false;
        self._dragIncoming = null;
      }

      // Abort (modal closed / component removed mid-slide): detach everything
      // WITHOUT starting playback; the caller resets video state itself
      function abort() {
        if (done) return;
        done = true;
        detach();
        self._transitioning = false;
        self._dragIncoming = null;
      }

      this._pendingTransition = { abort: abort };
      incoming.addEventListener('transitionend', cleanup);
      incoming.addEventListener('transitioncancel', cleanup);
      // Safety: if transitionend never fires (throttled tab, dropped frame),
      // force cleanup so navigation doesn't wedge
      timer = setTimeout(cleanup, 450);
    }

    /* Cancel whatever slide/snap-back is in flight (idempotent) */
    _abortPendingTransition() {
      if (this._pendingTransition) {
        this._pendingTransition.abort();
        this._pendingTransition = null;
      }
      this._transitioning = false;
      this._dragIncoming = null;
      this._dragging = false;
    }

    /* ── Helpers ── */

    _wrapIndex(i) {
      var len = this.videos.length;
      return ((i % len) + len) % len;
    }

    _resetVideo(v) {
      if (!v) return;
      v.pause();
      v.removeAttribute('src');
      v.load();
      v.classList.remove('ugc-gallery__video--active', 'ugc-gallery__video--sliding', 'ugc-gallery__video--visible');
      v.style.transform = '';
      v.style.transition = '';
    }

    /* play() returns a promise that rejects when the browser blocks playback
       (iOS unmuted autoplay outside a gesture). Reflect reality in the UI
       instead of leaving a frozen video behind a "Pause" icon. */
    _play(v) {
      if (!v || !v.currentSrc && !v.getAttribute('src')) return;
      var self = this;
      var p = v.play();
      if (p && typeof p.then === 'function') {
        p.then(function() { self.updatePlayIcon(); })
         .catch(function() { self.updatePlayIcon(); });
      }
    }

    toggleMute() {
      this._isMuted = !this._isMuted;
      if (this._activeVideo) this._activeVideo.muted = this._isMuted;
      this.updateMuteIcon();
    }

    updateMuteIcon() {
      if (!this.muteBtn) return;
      var mutedIcon = this.muteBtn.querySelector('.ugc-icon-muted');
      var unmutedIcon = this.muteBtn.querySelector('.ugc-icon-unmuted');
      if (mutedIcon) mutedIcon.classList.toggle('hidden', !this._isMuted);
      if (unmutedIcon) unmutedIcon.classList.toggle('hidden', this._isMuted);
      this.muteBtn.setAttribute('aria-label', this._isMuted ? 'Unmute' : 'Mute');
    }

    togglePlay() {
      if (!this._activeVideo) return;
      if (this._activeVideo.paused) {
        this._play(this._activeVideo);
      } else {
        this._activeVideo.pause();
      }
      this.updatePlayIcon();
    }

    updatePlayIcon() {
      if (!this.playBtn) return;
      var paused = this._activeVideo ? this._activeVideo.paused : true;
      var playingIcon = this.playBtn.querySelector('.ugc-icon-playing');
      var pausedIcon = this.playBtn.querySelector('.ugc-icon-paused');
      if (playingIcon) playingIcon.classList.toggle('hidden', paused);
      if (pausedIcon) pausedIcon.classList.toggle('hidden', !paused);
      this.playBtn.classList.toggle('ugc-gallery__play-btn--paused', paused);
      this.playBtn.setAttribute('aria-label', paused ? 'Play' : 'Pause');
    }
  }

  if (!customElements.get('ugc-gallery-component')) {
    customElements.define('ugc-gallery-component', UGCGalleryComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
